module.exports = __webpack_public_path__ + "common/tp-featured2-42c6bf108af8c3404f367cb8b9005dd1.svg";